<template>
  <div class="flex flex-col h-full overflow-y-hidden">
    <form @submit.prevent="handleSubmit(handleProceed)()">
      <div class="form-fields">
        <div class="grid grid-cols-2 gap-4 w-11/12 mx-auto">
          <VFormInput
            placeholder="Enter new title video"
            label="Add New Title*"
            @update="value => handleSetField('title', value)"
            :error="errors.title"
            :initialValue="editableVideo.title"
            :reset="!fieldsData.title"
            :classes="{ field: 'mb-0 ' }"
          />
          <VFormInput
            placeholder="Enter new order video"
            label="Add New Order*"
            @update="value => handleSetField('order', value)"
            :error="errors.order"
            :initialValue="editableVideo.order"
            :reset="!fieldsData.order"
            :classes="{ field: 'mb-0 ' }"
          />
          <VFormTextarea
            placeholder="Enter embedded code"
            label="Embedded Code*"
            @update="value => handleSetField('embed_code', value)"
            :error="errors.embed_code"
            :initialValue="editableVideo.embed_code || editableVideo.code"
            :reset="!fieldsData.embed_code"
            :classes="{ field: 'mb-0 ' }"
          />
          <VFormUploadImage
            :initialSrc="editableVideo.thumbnail_path"
            @upload="file => handleSetField('thumbnail', file)"
          />
          <button type="submit" class="text-white bg-gray-900 rounded py-4">
            {{ editable ? 'EDIT' : 'ADD' }}
          </button>
        </div>
      </div>
    </form>
    <ul class="px-5 overflow-y-auto">
      <li
        class="flex items-center justify-between px-4 py-4 border-b border-ricoma-gray-200 hover:bg-ricoma-gray-100"
      >
        <div class="w-3/12 font-bold text-center">Order</div>
        <div class="w-3/12 font-bold text-center">Title</div>
        <div class="w-3/12 font-bold text-center">Embed Code</div>
        <div class="w-3/12 font-bold text-center">Actions</div>
      </li>
      <li
        v-for="(video, index) in videos"
        :key="`video-${index}`"
        class="flex items-center justify-between px-4 py-4 border-b border-ricoma-gray-200 hover:bg-ricoma-gray-100"
      >
        <div class="w-3/12 text-center">{{ video.order }}</div>
        <div class="w-3/12 text-center">{{ video.title }}</div>
        <div class="w-3/12 text-center">{{ video.code || video.embed_code }}</div>
        <div class="flex justify-center w-3/12">
          <button class="mr-2 button-round edit" @click="handleSetEditable(video)">
            <VSvgIcon name="pencil" class="h-5" />
          </button>
          <button class="button-round delete" @click="handleDeleteVideo(video.id)">
            <VSvgIcon name="trash" class="h-5" />
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { formMixin } from '@/mixins';

import VFormTextarea from '@/components/base/VFormTextarea';
import VFormInput from '@/components/base/VFormInput';
import VSvgIcon from '@/components/base/VSvgIcon';
import VFormUploadImage from '@/components/base/VFormUploadImage';

export default {
  name: 'ProductVideoForm',
  components: {
    VFormTextarea,
    VFormUploadImage,
    VFormInput,
    VSvgIcon,
  },
  props: {
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    videos: {
      type: Array,
      required: false,
      default: () => [],
    },
    product_id: {
      type: Number,
      required: true,
    },
    language: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  mixins: [
    formMixin(
      {
        title: '',
        order: '',
        embed_code: '',
        thumbnail_path: '',
      },
      ['thumbnail_path', 'thumbnail'],
    ),
  ],
  data() {
    return {
      editableVideo: {},
    };
  },
  computed: {
    editable() {
      return this.editableVideo && !!Object.keys(this.editableVideo).length;
    },
  },
  methods: {
    handleSetEditable({ ...res }) {
      this.editableVideo = {
        ...res,
      };
    },
    handleReset() {
      this.handleResetFields();
      this.handleResetErrors();
      this.editableVideo = {};
    },
    async handleAddVideo({ ...data }) {
      const { code: lang_code } = this.language;
      const requestData = {
        ...data,
        product_id: this.product_id,
        lang_code,
      };
      const formData = new FormData();
      Object.keys(requestData).forEach(key => formData.append(key, requestData[key]));

      const result = await this.$http.post(`admin/product-videos/`, formData);
      this.videos.push(result.data.data);
      this.handleReset();
    },
    async handleUpdateVideo({ id, ...data }) {
      const { code: lang_code } = this.language;
      const requestData = {
        ...data,
        product_id: this.product_id,
        lang_code,
      };
      const formData = new FormData();
      Object.keys(requestData).forEach(key => formData.append(key, requestData[key]));
      const result = await this.$http.post(`admin/product-videos/${id}`, requestData);

      const objIndex = this.videos.findIndex(video => video.id === id);
      this.videos[objIndex] = result.data.data;
      this.handleReset();
    },
    async handleDeleteVideo(id) {
      await this.$http.delete(`admin/product-videos/${id}`);
      this.videos.splice(this.videos.indexOf(id), 1);
    },
    handleProceed(data) {
      this.editable
        ? this.handleUpdateVideo({
            id: this.editableVideo.id,
            title: data.title,
            order: data.order,
            embed_code: data.embed_code,
            thumbnail_path: data.thumbnail_path,
          })
        : this.handleAddVideo(data);
    },
  },
};
</script>
